import { IconButton, IconButtonProps } from '@mui/material';

import ArrowLeftIcon from 'modules/common/components/Icons/ArrowLeftIcon';
import { useNavigationUpdate } from 'modules/common/components/Navigator/context';
import { ScreenType } from 'modules/common/components/Navigator/context/NavigatorContext.interface';

export default function GoBack({ screen = '', ...props }: IconButtonProps & { screen?: ScreenType }) {
    const { goBack, navigateToPage } = useNavigationUpdate();

    const handleClick = () => {
        if (screen) {
            navigateToPage(screen);
            return;
        }
        goBack();
    };

    return (
        <IconButton aria-label="Go back" onClick={handleClick} sx={{ padding: 0 }} {...props}>
            <ArrowLeftIcon />
        </IconButton>
    );
}
